// CarePlanSection.jsx — Shared "Care Plan & Milestones" bottom section
import s from './shared.module.css';

export default function CarePlanSection({ goals, programs, tasks, followup }) {
  return (
    <div className={s.carePlanGrid}>
      {/* Goals */}
      <div className={s.carePlanBox}>
        <p className={s.carePlanBoxTitle}>
          <span>🎯</span> Goals
        </p>
        {(goals || [
          'Achieve healthy pregnancy in next 6 months',
          'Improve menstrual regularity',
          'Optimize weight and PCOS symptoms',
        ]).map((g, i) => (
          <div key={i} className={s.carePlanItem}>
            <span className={s.checkIcon}>✓</span>
            <span>{g}</span>
          </div>
        ))}
        <button className={s.btnGhost} style={{ marginTop: 6, fontSize: 11 }}>View Goals →</button>
      </div>

      {/* Active programs */}
      <div className={s.carePlanBox}>
        <p className={s.carePlanBoxTitle}>
          <span>💜</span> Active Programs
        </p>
        {(programs || [
          { name: 'Preconception Care Program', status: 'In Progress' },
          { name: 'PCOS Management Program', status: 'In Progress' },
        ]).map((p, i) => (
          <div key={i} className={s.carePlanItem}>
            <div style={{ flex: 1 }}>{p.name}</div>
            <span className={s.badgeGreen}>{p.status}</span>
          </div>
        ))}
        <button className={s.btnGhost} style={{ marginTop: 6, fontSize: 11 }}>View Programs →</button>
      </div>

      {/* Upcoming tasks */}
      <div className={s.carePlanBox}>
        <p className={s.carePlanBoxTitle}>
          <span>📋</span> Upcoming Tasks
        </p>
        {(tasks || [
          { name: 'Complete TSH Test', due: 'Due on 18 May 2026' },
          { name: 'Submit Day 2 Hormone Panel', due: 'Due on 22 May 2026' },
          { name: 'Track ovulation this cycle', due: 'Due on 25 May 2026' },
        ]).map((t, i) => (
          <div key={i} className={s.carePlanItem}>
            <span style={{ color: 'var(--ava-color-primary-400)', fontSize: 11 }}>☐</span>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 500, fontSize: 11, color: 'var(--ava-color-heading)' }}>{t.name}</div>
              <div style={{ fontSize: 10, color: 'var(--ava-color-caption)' }}>{t.due}</div>
            </div>
          </div>
        ))}
        <button className={s.btnGhost} style={{ marginTop: 6, fontSize: 11 }}>View All Tasks →</button>
      </div>

      {/* Next follow-up */}
      <div className={s.carePlanBox}>
        <p className={s.carePlanBoxTitle}>
          <span>📅</span> Next Follow-up
        </p>
        <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--ava-color-secondary-500)', margin: '4px 0' }}>
          {(followup || {}).date || '01 Jun 2025, 10:30 AM'}
        </div>
        <div style={{ fontSize: 11, color: 'var(--ava-color-heading)', fontWeight: 600 }}>
          {(followup || {}).doctor || 'Dr. Ananya Sharma'}
        </div>
        <div style={{ fontSize: 10, color: 'var(--ava-color-caption)' }}>
          {(followup || {}).specialty || 'Gynecologist'}
        </div>
        <div style={{ fontSize: 10, color: 'var(--ava-color-caption)', marginTop: 3 }}>
          📍 {(followup || {}).clinic || 'Avexa Women\'s Health Clinic, Mumbai'}
        </div>
        <button className={s.btnGhost} style={{ marginTop: 8, fontSize: 11, color: 'var(--ava-color-secondary-500)' }}>
          Reschedule
        </button>
      </div>
    </div>
  );
}